module.exports = __webpack_public_path__ + "media/images/icon_level_brown-b7c16b1002b697e631457add9fd81ecc.png";